"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEventDispatch = exports.useEventStream = exports.useEvent = void 0;
const operators_1 = require("rxjs/operators");
const shared_values_1 = require("./shared-values");
const use_once_1 = require("./use-once");
const useEvent = (eventType, callback) => {
    const [stream] = (0, shared_values_1.useSharedValue)(shared_values_1.APP_EVENTS, eventType);
    (0, use_once_1.useOnce)(() => {
        const sub = stream.subscribe(event => callback(event.payload));
        return () => sub.unsubscribe();
    });
};
exports.useEvent = useEvent;
const useEventStream = (eventType) => {
    const [stream] = (0, shared_values_1.useSharedValue)(shared_values_1.APP_EVENTS, eventType);
    return stream.pipe((0, operators_1.map)(event => event.payload));
};
exports.useEventStream = useEventStream;
const useEventDispatch = (event) => {
    const [stream] = (0, shared_values_1.useSharedValue)(shared_values_1.APP_EVENTS, event);
    return createEventDispatch(event, stream);
};
exports.useEventDispatch = useEventDispatch;
function createEventDispatch(event, stream) {
    return (payload) => {
        stream.next({
            type: event,
            payload
        });
    };
}
//# sourceMappingURL=use-event.js.map